(() => {
  const CONTAINER_ID = 'variant-selects-template--15487031738501__main';

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-sizechart]');
    if (!trigger) return;

    const container = document.getElementById(CONTAINER_ID);
    if (!container) return;

    const kiwiTrigger = container.querySelector('.ks-chart-modal-link');
    if (kiwiTrigger) kiwiTrigger.click();
  });
})();
